import React, { useState } from 'react';
import { OperationsLayer } from './OperationsLayer';
import { WorkflowMonitor } from './WorkflowMonitor';
import { ProcessObsDashboard } from './ProcessObsDashboard';

const TABS = [
  { id: 'ops',       label: 'Operations' },
  { id: 'workflows', label: 'Workflows'  },
  { id: 'processes', label: 'Processes'  },
] as const;

type OpsTab = typeof TABS[number]['id'];

export const OperationsHubView: React.FC = () => {
  const [active, setActive] = useState<OpsTab>('ops');

  return (
    <div className="flex flex-col h-full min-h-0">
      {/* Tab bar */}
      <div
        className="flex-shrink-0 flex gap-1 px-1 pt-1 pb-0"
        style={{ borderBottom: '1px solid var(--border-subtle)' }}
      >
        {TABS.map(tab => {
          const isActive = active === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActive(tab.id)}
              className="px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-none"
              style={{
                fontFamily: 'var(--font-ui)',
                color: isActive ? 'var(--accent-amber)' : 'var(--text-secondary)',
                borderBottom: isActive ? '2px solid var(--accent-amber)' : '2px solid transparent',
                backgroundColor: 'transparent',
                marginBottom: '-1px',
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab content */}
      <div className="flex-1 overflow-auto min-h-0">
        {active === 'ops'       && <OperationsLayer />}
        {active === 'workflows' && <WorkflowMonitor />}
        {active === 'processes' && <ProcessObsDashboard />}
      </div>
    </div>
  );
};
